import { gql } from 'apollo-boost'

const MENU_SCRAPING_REPORT_URL = gql`
  query menuScrapingReportUrl($id: ID!) {
    menuScrapingReportUrl(id: $id)
  }
`

export default MENU_SCRAPING_REPORT_URL
